export default __webpack_public_path__ + "static/media/cart-copy.e66b39f2.svg";